import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { Observable, of } from "rxjs";
import { PersonFlagService } from "../../person/person-flag.service";

@Component({
    selector: "adapt-dismissible-cta",
    templateUrl: "./dismissible-cta.component.html",
    styleUrls: ["./dismissible-cta.component.scss"],
    standalone: false,
})
export class DismissibleCtaComponent extends BaseComponent implements OnInit {
    @Input() public flag?: PersonFlag;
    @Input() public ctaStyle = 0;
    @Output() public dismissCta = new EventEmitter<boolean>();

    public ctaImage = "";
    public ctaBackgroundStyle = "";
    public dismissed$: Observable<boolean> = of(false);

    public constructor(
        private personFlagService: PersonFlagService,
    ) {
        super();
    }

    public async ngOnInit() {
        if (this.flag) {
            this.dismissed$ = this.personFlagService.isFlagEnabled$(this.flag);
        }

        this.ctaImage = (this.ctaStyle === 0)
            ? "/content/shell/images/content_header3.png"
            : "/content/shell/images/content_header2.png";


        this.ctaBackgroundStyle = `cta cta-style-${this.ctaStyle}`;
    }

    public dismiss(triggeredByRun: boolean = false) {
        if (this.flag) {
            this.personFlagService.setFlagAndSave(this.flag, true).pipe(
                this.takeUntilDestroyed(),
            ).subscribe(() => this.dismissCta.next(triggeredByRun));
        }
    }
}
